export default {"src":"/_next/static/media/Transport.0cd0d0a3.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};